

export const StatusType = {
    INACTIVE    : 1,
    ACTIVE      : 2,
    ASSIGNED    : 3,
    REMOVED     : 4,
    REVOKED     : 5,
}
